/* EcoBerry — Ingredients tabs section
   No dependencies. Safe to load on every page; it only acts on its own markup. */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.ebInit === 'true') return;
    root.dataset.ebInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-eb-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-eb-panel]'));
    var openBtn = root.querySelector('[data-eb-open]');
    var closeBtn = root.querySelector('[data-eb-close]');
    var full = root.querySelector('[data-eb-full]');
    var scrim = root.querySelector('[data-eb-scrim]');

    /* ---------- Full ingredient panel ---------- */

    function isOpen() {
      return full && !full.hidden;
    }

    function openFull() {
      if (!full) return;
      full.hidden = false;
      if (scrim) scrim.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      full.focus();
    }

    function closeFull(returnFocus) {
      if (!full || full.hidden) return;
      full.hidden = true;
      if (scrim) scrim.hidden = true;
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        if (returnFocus) openBtn.focus();
      }
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        if (isOpen()) {
          closeFull(true);
        } else {
          openFull();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeFull(true);
      });
    }

    if (scrim) {
      scrim.addEventListener('click', function () {
        closeFull(true);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        closeFull(true);
      }
    });

    /* ---------- Tabs ---------- */

    function selectTab(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });

      closeFull(false);

      if (moveFocus && tabs[index]) tabs[index].focus();
      if (panels[index]) syncPanel(panels[index]);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectTab(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        selectTab(next, true);
      });
    });

    /* ---------- Mobile slider dots ---------- */

    function syncPanel(panel) {
      var track = panel.querySelector('[data-eb-track]');
      var dotsWrap = panel.querySelector('[data-eb-dots]');
      if (!track || !dotsWrap) return;

      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) {
        dotsWrap.innerHTML = '';
        return;
      }

      if (dotsWrap.children.length !== cards.length) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (card, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'eb-ing__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        });
      }

      updateDots(track, dotsWrap);
    }

    function updateDots(track, dotsWrap) {
      var cards = Array.prototype.slice.call(track.children);
      var centre = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      var best = Infinity;

      cards.forEach(function (card, i) {
        var cardCentre = card.offsetLeft - track.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCentre - centre);
        if (distance < best) {
          best = distance;
          active = i;
        }
      });

      Array.prototype.slice.call(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-eb-track]');
      var dotsWrap = panel.querySelector('[data-eb-dots]');
      if (!track || !dotsWrap) return;

      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            updateDots(track, dotsWrap);
            ticking = false;
          });
        },
        { passive: true }
      );

      if (!panel.hidden) syncPanel(panel);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-eb-ingredients]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Re-run when the theme editor reloads this section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
